// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"340": "d6d699e0efd89863","435": "405fa66bd2e8425b","795": "2953e88ef98981f3","895": "7d9ef7bfa0d6b6ea","924": "6e6f0f58cd9b2995",}[chunkId] + ".css"
}